import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetConfiguracaoCampoObrigatorioResponse } from '@shared/services/responses/financas/configuracao-campo-obrigatorio.response';
import { ConfiguracaoCampoObrigatorioRequest } from '@shared/services/requests/financas/configuracao-campo-obrigatorio.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

/**
 * Campos obrigatórios configuráveis da API Produto (ConfiguracaoCampoObrigatorioController).
 * O contrato é o mesmo de Finanças, por isso reaproveita os tipos de financas/.
 */
@Injectable({
    providedIn: 'root',
})
export class ProdutoConfiguracaoCampoObrigatorioService extends CommonService {
    private readonly apiUrl: string = environment.urlApiProduto + 'ConfiguracaoCampoObrigatorio';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(): Observable<GetConfiguracaoCampoObrigatorioResponse> {
        return this.httpClient
            .get<GetConfiguracaoCampoObrigatorioResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getByTela(idTela: number): Observable<GetConfiguracaoCampoObrigatorioResponse> {
        return this.httpClient
            .get<GetConfiguracaoCampoObrigatorioResponse>(this.apiUrl + '/idTela/' + idTela, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(request: ConfiguracaoCampoObrigatorioRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
